import React, { useContext } from "react";
export const FeatureFlagsContext = React.createContext({});
export const useFeatureFlag = (flag) => {
    const allFlags = useContext(FeatureFlagsContext);
    return allFlags[flag] ?? false;
};
